<template>
    <div>
        <Table :data="tableData1" :loading="loading" class="tableBorder" height="500" :columns="tableColumns1" size="small" :show-header="showheader"></Table>
        <br />
        <Row>
            <Col span="24">
            <Page ref="pager" :total="pageTotal" :page-size="pagesize" :current.sync="pageIndex" @on-change="changePage"></Page>
            </Col>
        </Row>
    </div>
</template>
<script>
import eventBus from '../../common/event_bus.js'
import store from '../../../store'
export default {
    name: 'tax_incentives_table',
    // props: { mydata: Object, },
    data() {
        return {
            tableData1: [], //this.mockTableData1(), //tabledata.tabrows,
            tableColumns1: [], //this.mockTableHeader(),
            showHeaders: [],
            pageTotal: 0,
            showheader: false,
            pageIndex: 1,
            pagesize: 10,
            src: '',//1=通用，2=专属，3=最新文件，4=效力变动,5=优惠项目，6=优惠税种
            loading: true,
            tempData:{},
        }
    },
    inject: ['CreatePage', 'getSliders'],
    methods: {
        mockTableData2(tabrows) {
            //console.log(this.mydata)
            let da = [];
            let items = tabrows //this.mydata.tabrows
            if (items && items.length > 0) {
                for (var i = 0; i < items.length; i++) {
                    da.push({
                        fileid: items[i].strdocid,
                        filename: items[i].fname,
                        filenumber: items[i].fcode,
                        potence: items[i].potence,
                        pdate: items[i].pdate,
                        publisher: items[i].publisher,
                        tax:items[i].tax,
                    })
                }
            }
            return da;
        },

        mockTableHeader2(header, headerTitle) {
            var that = this
            let da = [];
            let items = header //this.mydata.header;
            let newHeaders = [];
            this.setHeader(headerTitle)
            for (var i = 0; i < items.length; i++) {
                if (this.showHeaders.indexOf(items[i].key) >= 0) {
                    newHeaders.push(items[i])
                }
            }
            //console.log(newHeaders)
            items = newHeaders;
            // da.push({
            //     type: 'index',
            //     width: 60,
            //     align: 'center'
            // })
            da.push({
                title: '序号',
                align: 'center',
                width: 60,
                sortable: true,
                render: (h, params) => {
                    return h('span', params.index + (this.pageIndex - 1) * this.pagesize + 1)
                }

            })
            for (var i = 0; i < items.length; i++) {
                if (items[i].key == "filename") {
                    da.push({
                        title: items[i].title,
                        key: items[i].key,
                        //align: items[i].align,
                        render: (createElement, params) => {
                            const row = params.row;
                            const text = row.filename;
                            const fileid = row.fileid;
                            const desc = row.potence;
                            const datestr = row.pdate;
                            const publisher = row.publisher;
                            const strtax= row.tax;
                            return createElement('div', {
                                style: {
                                    color: '#515a6e',
                                    marginTop: '5px',
                                    marginBottom: '5px',
                                }
                            }, [
                                createElement('a', {
                                    domProps: {
                                        innerHTML: `` + text + ``
                                    },
                                    style:{
                                        fontSize:'14px',
                                    },
                                    on: {
                                        'click': () => {
                                            //row.isread = true
                                            that.add(fileid, 1, text,row);
                                        }
                                    }
                                }, text + " "),
                                ' ',
                                // createElement('Tag', {
                                //     props: {
                                //         color: 'warning',
                                //     },
                                //     style: {
                                //         marginLeft: '20px',
                                //         width: '60px',
                                //         textAlign: 'center',
                                //         display: !row.isread ? 'inline-block' : 'none'
                                //     }
                                // }, readstr),

                                // <span style="padding-left:20px;font-weight:bold;">税种:</span>`+strtax+`

                                createElement('p', {
                                    domProps: {
                                        innerHTML: `<span style="font-weight:bold;">成文时间：</span>`+datestr+`
                                                    <span style="padding-left:20px;font-weight:bold;">制定（发文）单位:</span>`+publisher+`
                                                    <span style="padding-left:20px;font-weight:bold;">文件效力:</span>`+desc+`
                                                    <span style="padding-left:20px;font-weight:bold;">税种:</span>`+strtax+`
                                                    `
                                    },
                                    style: {
                                        color: '515a6e'
                                    }
                                }),

                            ]);
                        }
                    })

                } else {
                    da.push({
                        title: items[i].title,
                        key: items[i].key,
                        // width: items[i].width,
                        //align: items[i].align,
                    })
                }

            }

            return da;
        },
        setHeader(arrayObj) {
            if (arrayObj == null || arrayObj == undefined || arrayObj.length == 0) {
                this.showHeaders = ['fileid', 'filename']

            } else {
                this.showHeaders = arrayObj
            }
        },
        changePage(index) {
            if (this.checkAccessPromission()) {
                if (this.checkUserLogin()) {
                    this.loading = true
                    this.$emit('changepage', index, this.src)
                }else{
                     this.$nextTick(function() {
                        this.$refs.pager.currentPage = 1
                    })
                    console.log('uploadResult user-login')
                    eventBus.$emit("user-login", "true", '2') //临时登录
                }
            }else{
                //  this.$nextTick(function() {
                //     this.$refs.pager.currentPage = 1
                // })
                 this.$emit('changepage', 1, this.src)
            }
            
        },
        add(fid, orderid, filename,row) {
            this.CreatePage(fid, orderid, filename,row);
        },
        reloadHeaderData(obj) {
            this.tableColumns1 = this.mockTableHeader2(obj);
        },
        show(data, type) {
            this.src = type
            this.pageIndex = data.index
            this.tableName = data.tabname
            this.pageTotal = data.total
            this.tempData= data
            this.tableData1 = this.mockTableData2(data.tabrows)
            this.tableColumns1 = this.mockTableHeader2(data.header, ['filename'])
            this.loading = false
            this.$nextTick(() => {
                this.loading = false
            })

        },
        checkAccessPromission() {
            console.log("this.getVersion====>" + this.getVersion)
            console.log("this.$refs.pager.currentPage===>" + this.$refs.pager.currentPage)
            console.log(this.tempData)
            if (this.tempData.warninglevel === 0) {
                return true
            } else if (this.tempData.warninglevel === 1 && !this.checkUserLogin()) {
                //提示登录
                console.log('检查页面访问权限1===>')
                eventBus.$emit("user-login", "true", '2') //临时登录,2=登录成功需要刷新页面地方版
                // this.show(this.tempData,this.src)
            } else if (this.tempData.warninglevel === 2) {
                if (this.$refs.pager.currentPage > 1) {
                    //提示去商城
                    console.log('检查页面访问权限2===>')
                    eventBus.$emit('user-nopermission-board', this.tempData.warningtext, 1)
                    return false
                } else {
                    return true
                }

            } else if (this.tempData.warninglevel === 3) {
                if (this.$refs.pager.currentPage > 1) {
                    //提示去商城
                    console.log('检查页面访问权限3===>')
                    eventBus.$emit('user-nopermission-board', this.tempData.warningtext, 2)
                    return false
                } else {
                    return true
                }
            }
        },
        checkUserLogin() {
            if (store.state.user.accounttype == 0) {
                return false
            } else {
                return true
            }
        },

    },
    watch: {
        sliders: function() {
            // console.log(this.sliders)
            // this.reloadHeaderData(['filename']);
            // if (this.sliders.length == 0) {
            //     this.reloadHeaderData([]);
            // } else if (this.sliders.length > 0) {
            //     this.reloadHeaderData(['filename']);
            // }
        },
    },
}
</script>
<style scoped>
.tableBorder {
    /*border: 1px solid #dcdee2;*/
    border-bottom: none;
}
.tableBorder>.ivu-table>.ivu-table-overflowX {
    overflow-x: hidden;
}
#my_file_info{
    padding-left: 100px;
    background-color: yellow;
}
</style>